window.bssB2BHooks = window.bssB2BHooks || {
  actions: {},
  filters: {},
};
window.BSS_B2B = window.BSS_B2B || {};
window.BSS_B2B.addAction = (tag, callback) => {
  window.bssB2BHooks.actions[tag] = callback;
};
window.BSS_B2B.addFilter = (tag, value) => {
  window.bssB2BHooks.filters[tag] = value;
};

const handleCartPrice = (cartSubject, e) => {
  fetch('/cart.js').then(response => response.json()).then(data => {
    let total = 0;
    let appliedCP = false;
    for (let i = 0; i < data.items.length; i++) {
      const item = data.items[i];
      const variant = BSS_B2B.storage.variantStorage.get(item.variant_id);
      if (variant?.appliedCP) {
        appliedCP = true;
        document.querySelector(`#CartDrawer-Form h-cart-item[variant_id="${item.variant_id}"]`).shadowRoot.querySelector(".pricing").innerHTML = BSS_B2B.formatMoney(variant.bssB2BPriceAfterCP);
        total += variant.bssB2BPriceAfterCP*item.quantity;
      }
    }
    if (appliedCP) {
      if (document.querySelector("button#CartDrawer-Checkout")) document.querySelector("button#CartDrawer-Checkout").style.display = "none";
      if (document.querySelector(".bss-checkout")) document.querySelector(".bss-checkout").style.display = "block";
      if (document.querySelector(".vt-new_price")) document.querySelector(".vt-new_price").setAttribute("bss-b2b-cart-total-price", "");
      if (document.querySelector(".drawer__inner")) document.querySelector(".drawer__inner").setAttribute("bss-b2b-has-cp", "");
      if (document.querySelector(".vt-new_price")) document.querySelector(".vt-new_price").style.visibility = "visible";
      if (document.querySelector(".bss-cart-total")) document.querySelector(".bss-cart-total").style.display = "flex";
      if (cartSubject) cartSubject.notifyObserver('CartPriceMutate', 'ClickOpenMiniCart', {
          event: e,
      });
      setTimeout(() => {
        if (document.querySelector(".bss-cart-total")) document.querySelector(".bss-cart-total").style.display = "flex";
        if (document.querySelector(".vt-new_price")) document.querySelector(".vt-new_price").innerHTML = BSS_B2B.formatMoney(total);
      }, 500)
    }
  })
}
const handleFixCart = (element, cartSubject) => {
    if(element.length) {
        element.forEach((btn) => {
            btn.addEventListener('click', (e) => {
                handleCartPrice(cartSubject, e);
            })
        })
    }
}
const customCartEvent = ({cartSubject}) => {
    const buttonAddToCarts = document.querySelectorAll('[bss-b2b-cart-trigger-added], .btn--add-to-cart, .header__icon');
    handleFixCart(buttonAddToCarts, cartSubject);
    handleCartPrice();
}
window.BSS_B2B.addAction('custom:cart/event', customCartEvent);
window.addEventListener("cart_changed", () => {
console.log("cart_changed")
  setTimeout(() => {
    handleCartPrice();
  }, 2000)
});